module.exports = __webpack_public_path__ + "static/media/HelveticaNeueLTStd-Lt.78af9e64.woff";